import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { getMemberTableSubjectDisplayName } from "@components/table/members/members-table-utils";
import { useAppSelector } from "@store/store-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of bulk dialog and bulk success dialog for removing member */
export function useRemoveMemberBulkDialogContent(memberTableSubject) {
  const $ = _c(19);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  let t0;
  if ($[0] !== memberTableSubject) {
    t0 = getMemberTableSubjectDisplayName(memberTableSubject);
    $[0] = memberTableSubject;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tableSubjectName = t0;
  const t1 = `Remove members from the ${tableSubjectName}?`;
  const t2 = `When you confirm this action, 
      the following members will no longer be able to access this ${tableSubjectName}.`;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      title: t1,
      description: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `Couldn't remove ${numberOfErrors} of ${numberOfUpdatingItems} members`;
  const t5 = `These members couldn't be removed from this ${tableSubjectName},
      check the details and try again.`;
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      title: t4,
      description: t5
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = {
      initial: t3,
      failed: t6,
      confirmButtonText: "remove",
      entityType: "member"
    };
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const bulkDialogContent = useGetBulkDialogContent(t7);
  let t8;
  if ($[11] !== numberOfSuccess) {
    t8 = nounPluralize({
      counter: numberOfSuccess,
      word: "member"
    });
    $[11] = numberOfSuccess;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = `${t8} removed`;
  const t10 = `All selected members have been removed from this ${tableSubjectName}.`;
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = {
      title: t9,
      description: t10
    };
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const successDialogContent = t11;
  let t12;
  if ($[16] !== bulkDialogContent || $[17] !== successDialogContent) {
    t12 = {
      bulkDialogContent,
      successDialogContent
    };
    $[16] = bulkDialogContent;
    $[17] = successDialogContent;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}